import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeFamilyMember, EmployeeFamilyMemberCreate, EmployeeFamilyMemberFilter } from '../data/employeeFamilyMember';

export function createEmployeeFamilyMemberService(client: AxiosInstance) {
  return createCrudService<EmployeeFamilyMember, EmployeeFamilyMemberCreate, EmployeeFamilyMemberFilter>(
    client,
    '/hrm/EmployeeFamilyMember',
    'id',
  );
}

export type EmployeeFamilyMemberService = CrudService<EmployeeFamilyMember, EmployeeFamilyMemberCreate, EmployeeFamilyMemberFilter>;
